export const isErrorForm = (form) => {
    const errorValues = Object.values(form).map((x) => x.error);
    return errorValues.some((x) => x);
};

export const tiempoCierreSession = 1200000;
export const isNullOrEmpty = (value) => !value || value === "";
